import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: React.ReactNode;
}
const FeaturePointGlpAdv3 = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-2056">
      <div className="flex-shrink-0 mt-1" data-id="element-2057">
        <CheckIcon className="h-4 w-4 text-green-600" data-id="element-2058" />
      </div>
      <div className="ml-2 text-sm text-green-600" data-id="element-2059">{children}</div>
    </div>;
};
export default FeaturePointGlpAdv3;